import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ENV } from 'src/constants';
import { RootState } from 'src/redux/reducers/rootReducer';

export const useEnv = () => {
  const currentEnv = useSelector((state: RootState): string => state.main.env);
  const isProdEnv = useMemo(() => currentEnv === ENV.PRODUCTION, [currentEnv]);

  return { isProdEnv, currentEnv };
};
